import { DEMO_BASE } from './constants.js'

/**
 * Prefix a path with /maptac/demo. Query strings and hashes are preserved.
 * @param {string} path
 * @returns {string}
 */
export function demoPath(path = '') {
  if (path == null || path === '' || path === '/') return DEMO_BASE
  const queryIndex = path.indexOf('?')
  const hashIndex = path.indexOf('#')
  const cuts = [queryIndex, hashIndex].filter((index) => index >= 0)
  const end = cuts.length ? Math.min(...cuts) : path.length
  let pathname = path.slice(0, end)
  const rest = path.slice(end)
  if (!pathname.startsWith('/')) pathname = `/${pathname}`
  if (pathname === DEMO_BASE || pathname.startsWith(`${DEMO_BASE}/`)) {
    return `${pathname}${rest}`
  }
  return `${DEMO_BASE}${pathname}${rest}`
}
